import React, { FC, RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  AlertColor,
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/system';
import axios from 'axios';
import dayjs from 'dayjs';
import { parseTimeValue } from 'components/TimeInput/TimeInput';
import { CountryCode } from 'libphonenumber-js';
import { flushSync } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { routes } from '../../../utils/constants/routes';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Config from '../../../utils/Config';
import { identifiers } from '../../../utils/constants/identifiers';
import { useCustomNavigate } from 'utils/hooks/useCustomNavigate';
import { pageTitleSx } from 'utils/styles/pageHeader';
import {
  isDirectBooking,
  organizationInfo,
  selectIntegration,
  User,
} from '../../../utils/redux/reducer/authentication-slice';
import { cloneBookingFromRFQ, setOpenPanelAddon } from '../../../utils/redux/reducer/booking-slice';
import {
  selectedVenuesNewBooking,
  setSelectedVenuesForCosting,
  setSelectedVenuesForNewBooking,
} from '../../../utils/redux/reducer/costing-slice';
import { setSearchDataSliceInitState } from '../../../utils/redux/reducer/searched-data-slice';
import { fetchFromStorage, removeFromStorage } from '../../../utils/storage';
import strings from '../../../common/Translation/Translate';
import DrawerMenu from '../../../components/DrawerMenu';
import Form, { FormDataModel } from '../../../components/Form';
import Notification from '../../../components/Notification';
import PageLoader from '../../../components/PageLoader';
import axiosInstance from '../../../utils/axios';
import { URLS } from '../../../utils/constants/urls';
import { removeErrorFieldsFromValues } from '../../../utils/validators';
import {
  createDropdownData,
  createLayoutDropdownData,
  downloadExportFile,
  fetchErrorFields,
  fetchIdsFromSelectedDropdownValues,
  getDrawerWidth,
  getFileName,
  buildVenuesForEventType,
  VenueEventCapacity,
} from '../../../utils/validators/HelperFunctions';
import { AddEditBookingRooms } from '../BookingDetail/BookingDetailButtons/EditBooking/AddEditBookingRooms/AddEditBookingRooms';
import {
  ExternalBookedRoomPayload,
  YcsRoomBooking,
} from '../BookingDetail/BookingDetailButtons/EditBooking/AddEditBookingRooms/YcsRoomBooking';
import { CostingComponent } from './CostingComponent';
import LineItemsTableComponent from './LineItemsTableComponent';
import LineItemDrawerComponent from './LineitemDrawerComponent';
import { buildClonedLineItemDrawerState } from './lineItemCloneUtils';
import {
  extractCostingErrorMessage,
  isLineItemReadyForCosting,
  resolveCurrentLineItemForCosting,
} from './venueDetailsCostingUtils';
import { NewBookingForm } from './NewBookingForm';
import { EmailAttachmentCheckboxes, EmailFileAttachments } from './NewBookingSendEmailComponent';
import {
  appendEmailAttachmentOptions,
  getEmailAttachmentVisibility,
} from './NewBookingSendEmailComponent/emailAttachmentOptions';
import { NewBookingSendEmailFormComponent } from './NewBookingSendEmailComponent/SendEmailFormComponent';
import PreviewContract from './PreviewContract';
import ReviewTabSummary, { buildCustomerName, formatBookingDateRange, labelForId } from './ReviewTabSummary';
import CKEditor5 from 'components/CkEditor5';
import Section from 'components/Section/Section';
import { NewBookingForm2 } from './NewBookingForm2';
import PrimaryButton from 'components/Button/PrimaryButton';
import {
  PaymentScheduleSection,
  pickPaymentScheduleValues,
  validatePaymentSchedule,
} from 'components/PaymentScheduleSection';
import Navigation from 'utils/hooks/Navigation';
import { PreviewPopover } from './PreviewPopover';
import AddEditCustomer from '../Customer/AddEditCustomer/AddEditCustomer';
import { isCustomizePackage, normalizeCustomPricePackageName } from 'utils/pricePackage';

const CONTRACT = identifiers.CONTRACT;
const PROPOSAL = identifiers.PROPOSAL;
const PI = identifiers.PI;
const ENQUIRY = identifiers.ENQUIRY;

const isTruthyFlag = (value: unknown) => value === true || value === 'true';

const resolveClonedCorporateBooking = (data: any): 'true' | 'false' => {
  const flag = data?.corporateBooking ?? data?.isCorporateBooking;
  if (flag != null && flag !== '') {
    return isTruthyFlag(flag) ? 'true' : 'false';
  }
  if (data?.companyMaster && data?.companyBranch && data?.contactedWith) {
    return 'true';
  }
  return 'false';
};

const NewBooking: FC = () => {
  type MyType = Form | null | undefined;
  const roomAvailable = true;
  let formRef1: RefObject<MyType> = useRef();
  let formRef2: RefObject<MyType> = useRef();

  const { id } = useParams() as any;
  const cloneFromRFQ = useSelector(cloneBookingFromRFQ);
  const location = useLocation();
  const loggedInUserDetails = useSelector(User);
  const org = useSelector(organizationInfo) as any;
  const directBooking = useSelector(isDirectBooking);
  const integration = useSelector(selectIntegration);
  const useYcsRooms = (integration || '').toUpperCase() === 'YCS';
  const selectedVenues = useSelector(selectedVenuesNewBooking);
  const defaultCountry = (fetchFromStorage('defaultCountryCode') || 'IN') as CountryCode;
  const Navigate = useCustomNavigate();
  const token: any = fetchFromStorage(identifiers.access_token);
  const theme = useTheme();
  const dispatch = useDispatch();
  const screenSizeDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const screenSizeDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const screenSizeUpLg = useMediaQuery(theme.breakpoints.up('lg'));
  let lineItemFormRef: RefObject<MyType> = useRef();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pdfUrl, setPdfUrl] = useState<any>('');
  const [pageResponse, setPageResponse] = useState<any>({ corporateBooking: 'true' });
  const [paymentDetails, setPaymentDetails] = useState<any>([]);
  const [openPdfDrawer, setOpenPdfDrawer] = useState<string | boolean>(false);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [isEditDrawer, setIsEditDrawer] = useState<boolean>(false);
  const [isCloneDrawer, setIsCloneDrawer] = useState<boolean>(false);
  const [lineItemsPageResponse, setLineItemsPageResponse] = useState<any>({});
  const [lineItems, setLineItems] = useState<any>([]);
  const [hasError, setHasError] = useState<boolean>(false);
  const [lineItemHasError, setLineItemHasError] = useState<boolean>(false);
  const [selectedRowId, setSelectedRowId] = useState<any>(null);
  const [sourceList, setSourceList] = useState<any>([]);
  const [revenueOwnerList, setRevenueOwnerList] = useState<any>([]);
  const [eventTypeList, setEventTypeList] = useState<any>([]);
  const [venueList, setVenueList] = useState<any>([]);
  const [baseVenueList, setBaseVenueList] = useState<any>([]);
  const [venueEventCapacities, setVenueEventCapacities] = useState<VenueEventCapacity[]>([]);
  const [venueMaxCapacity, setVenueMaxCapacity] = useState<number | null>(null);
  const [statusList, setStatusList] = useState<any>([]);
  const [partOfDayList, setPartOfDayList] = useState<any>([]);
  const [bookingConfirmationList, setBookingConfirmationList] = useState<any>([]);
  const [layoutList, setLayoutList] = useState<any>([]);
  const [taxGroupList, setTaxGroupList] = useState<any>([]);
  const [serviceChargeList, setServiceChargeList] = useState<any>([]);
  const [pricePackageList, setPricePackageList] = useState<any>([]);
  const [selectedVenue, setSelectedVenue] = useState<string>('');
  const [selectedEventType, setSelectedEventType] = useState<string>('');
  const [maxCount, setMaxCount] = useState<number>(0);
  const [addonsList, setAddonsList] = useState<any>([]);
  const [bookedAddOns, setBookedAddOns] = useState<any>([]);
  // const [roomAvailable, setRoomAvailable] = useState<boolean>(false);
  const [gridError, setGridError] = useState<boolean>(false);
  const [roomGridError, setRoomGridError] = useState<boolean>(false);
  const [costingDrawerPageResponse, setCostingDrawerPageResponse] = useState<any>({});
  const [costingSummaryLoading, setCostingSummaryLoading] = useState<boolean>(false);
  const [costingSummaryError, setCostingSummaryError] = useState<string | null>(null);
  const costingSummaryRequestSeqRef = useRef(0);
  /** Sync guard so a second Create click in the same tick cannot start another POST. */
  const savingRef = useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const bookingIdempotencyKeyRef = useRef(
    typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`,
  );
  const [rooms, setRooms] = useState<any>([]);
  const [externalBookedRooms, setExternalBookedRooms] = useState<ExternalBookedRoomPayload[]>([]);
  const [selectedStartDate, setSelectedStartDate] = useState<any>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<any>(null);
  const [additionalComments, setAdditionalComments] = useState<any>('');
  const [activeTab, setActiveTab] = useState<number>(0);
  const [includeRoomsTab, setIncludeRoomsTab] = useState<boolean>(false);
  const [isComplementary, setIsComplementary] = useState<boolean>(false);
  const [hourlyPricing, setHourlyPricing] = useState<boolean>(false);
  const [restrictPriceOverride, setRestrictPriceOverride] = useState<boolean>(false);
  const [pastBookingWindowDays, setPastBookingWindowDays] = useState<number | null>(null);
  // const [roomsList, setRoomsList] = useState<any>([]);
  const [defaultPricePerPerson, setDefaultPricePerPerson] = useState<any>('');
  const [defaultMinimumRevenue, setDefaultMinimumRevenue] = useState<any>('');
  const [defaultPricePerHour, setDefaultPricePerHour] = useState<any>('');
  const [fixedHallRental, setFixedHallRental] = useState<any>(undefined);

  //send email setStates
  let sendEmailFormRef: RefObject<MyType> = useRef();
  const [sendEmailHasError, setSendEmailHasError] = useState<boolean>(false);
  const [sendEmailPageResponse, setSendEmailPageResponse] = useState<any>({});
  const [attachment, setAttachment] = useState<any>([]);
  const [deletedImage, setDeletedImage] = useState<any>([]);
  const [pageData, setPageData] = useState<any>(null);
  const [captureLoyaltyProgram, setCaptureLoyaltyProgram] = useState<boolean>(false);
  const [isContractTemplatePresent, setIsContractTemplatePresent] = useState<boolean>(false);
  const [isProposalTemplatePresent, setIsProposalTemplatePresent] = useState<boolean>(false);
  const [isPiTemplatePresent, setIsPiTemplatePresent] = useState<boolean>(false);
  const [isEnquiryTemplatePresent, setIsEnquiryTemplatePresent] = useState<boolean>(false);
  const emailAttachmentVisibility = useMemo(
    () =>
      getEmailAttachmentVisibility({
        isContractTemplatePresent,
        isProposalTemplatePresent,
        isPiTemplatePresent,
        isEnquiryTemplatePresent,
        isEnquiryStatus: lineItems?.some((item: any) => item.status === 'ENQUIRY'),
      }),
    [isContractTemplatePresent, isProposalTemplatePresent, isPiTemplatePresent, isEnquiryTemplatePresent, lineItems],
  );
  const [isOdc, setIsOdc] = useState<boolean>(false);
  const [pageRequest, setPageRequest] = useState<any>([]);
  const [companyMasters, setCompanyMasters] = useState<any>([]);
  const [branches, setBranches] = useState<any[]>([]);
  const [contacts, setContacts] = useState<any[]>([]);
  const [contactsFullData, setContactsFullData] = useState<any[]>([]); // Store full contact data with GSTIN
  const [salutations, setSalutations] = useState<any[]>([]);
  const [showContactModal, setShowContactModal] = useState<boolean>(false);
  const [salesManagementEnabled, setSalesManagementEnabled] = useState<boolean>(false);
  const [eventSubtypeOptions, setEventSubtypeOptions] = useState<any[]>([]);
  const [paymentScheduleErrors, setPaymentScheduleErrors] = useState<Record<string, string>>({});

  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: any;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  const NotificationAction = (data: any) => {
    const id = data.bookingLineItems[0].id;
    return (
      <>
        <Typography sx={{ display: 'inline' }} variant="subtitle1">
          <b>{strings.NewBookingSuccess}</b>
        </Typography>
        <Typography variant="subtitle2" sx={{ display: 'inline' }}>
          {strings.NewBookingSuccessPart1}
        </Typography>
        <Typography
          onClick={() => Navigate(`${routes.editBooking}/${id}`)}
          variant="subtitle2"
          sx={{ display: 'inline', cursor: 'pointer', color: 'aqua' }}>
          <u>{strings.NewBookingSuccessPart2}</u>
        </Typography>
        <Typography variant="subtitle2" sx={{ display: 'inline' }}>
          {strings.NewBookingSuccessPart3}
        </Typography>
      </>
    );
  };

  const closeNotification = useCallback((value: boolean) => {
    setMessage(prevState => ({ ...prevState, display: value }));
  }, []);

  const jsonQuery = (data: any, requestBody: any, key: any) => {
    //bookedRooms[0].pricingDetails[0].roomWiseDetals
    const keys = data.split('.', data.split('.').length - 1); // [bookedRooms[0], pricingDetails[0]]
    let temp = JSON.parse(JSON.stringify(requestBody));
    keys.forEach((k: any) => {
      const a = k.split('['); //[bookedRooms, 0] ]
      temp = temp[a[0]][a[1].slice(0, -1)]; // requestBody['bookedRooms'][0]
    });
    return temp[key];
  };

  const handleCatch = useCallback((error: any, requestBody?: any) => {
    let msg: string;
    if (error.response) {
      debugger;
      if (error.response.data?.errors && requestBody) {
        const temp = error.response.data?.errors[0].field.split('.');
        const m1 = temp[temp.length - 1];
        const date = jsonQuery(error.response.data?.errors[0].field, requestBody, 'checkIn');
        msg = `${m1} for ${date} ${error.response.data?.errors[0].defaultMessage}`;
      } else {
        msg = error.response.data?.error_description
          ? error.response.data.error_description
          : error.response.data.message;
      }
    } else {
      msg = error.message;
    }
    setMessage({
      display: true,
      severity: 'error',
      message: msg,
    });
  }, []);

  const getRevenueOwners = async (branchId: number | null = null) => {
    try {
      const url = URLS.revenueOwners(branchId);
      const { data } = await axiosInstance.get(url);
      const revenueOwners = Array.isArray(data)
        ? data.map((item: any) => ({
            label: item.name || item.label || '',
            value: item.id || item.value || '',
          }))
        : [];
      setRevenueOwnerList(revenueOwners);
      setPageResponse((prevState: any) => ({
        ...prevState,
        revenueOwners: [],
      }));
      formRef1.current?.handleChange([] as any, 'revenueOwners', { error: false, message: '' });
    } catch (error: any) {
      handleCatch(error);
    }
  };

  const getDropdowns = async () => {
    const { data } = await axiosInstance.get(URLS.getDataForNewBooking);

    const agents = createDropdownData(data?.agents, ['id', 'name']);
    const eventTypes = createDropdownData(data?.eventTypes, ['id', 'name']);
    const venues = createDropdownData(data?.venues, ['id', 'name']);
    const capacities = data?.venueEventCapacities ?? [];
    const bookingStatuses = createDropdownData(data?.bookingStatuses, ['id', 'name']);
    const partOfDays = createDropdownData(data?.partOfDays, ['id', 'name']);
    const bookingConfirmationByList = createDropdownData(data?.bookingConfirmationByList, ['id', 'name']);
    setEventSubtypeOptions(createDropdownData(data?.eventSubTypes, ['name', 'name']));
    setSourceList(agents);
    setEventTypeList(eventTypes);
    setIsOdc(data.isOdc);
    setBaseVenueList(venues);
    setVenueEventCapacities(capacities);
    setVenueList(buildVenuesForEventType(venues, capacities, selectedEventType));
    setStatusList(bookingStatuses);
    setPartOfDayList(partOfDays);
    setBookingConfirmationList(bookingConfirmationByList);
    setRestrictPriceOverride(data.restrictPriceOverride);
    setPastBookingWindowDays(data.pastBookingWindowDays ?? null);
    // setRoomAvailable(data.roomsAvailable);
    setCaptureLoyaltyProgram(data.captureLoyaltyProgram);
    setIsContractTemplatePresent(data.isContractTemplatePresent);
    setIsProposalTemplatePresent(data.isProposalTemplatePresent);
    setIsPiTemplatePresent(data.isPiTemplatePresent);
    setIsEnquiryTemplatePresent(data.isEnquiryTemplatePresent);
    if (!id && data.defaultAdditionalComments) {
      setAdditionalComments(data.defaultAdditionalComments);
    }
    setPaymentDetails({
      minConfirmPaymentPercentage: data.minConfirmPaymentPercentage,
      paymentSlotOnePercentage: data.paymentSlotOnePercentage,
      paymentSlotTwoPercentage: data.paymentSlotTwoPercentage,
      paymentSlotThreePercentage: data.paymentSlotThreePercentage,
      paymentSlotOneBeforeDays: data.paymentSlotOneBeforeDays,
      paymentSlotTwoBeforeDays: data.paymentSlotTwoBeforeDays,
      fullPaymentBeforeDays: data.fullPaymentBeforeDays,
      holdDays: data.holdDays,
      bookingConfirmationBy: data.bookingConfirmationBy,
    });
    const isSalesManagementEnabled = !!data.isSalesManagementEnabled;
    setSalesManagementEnabled(isSalesManagementEnabled);
    await getRevenueOwners(null);
  };

  // const getRoomsList = async () => {
  //   const { data } = await axiosInstance.get(URLS.RoomTypeList);
  //   const filter = data.map((item: any) => {
  //     return { label: item.name, value: item.id };
  //   });
  //   setRoomsList(filter);
  // };

  const getMasterData = useCallback(async () => {
    try {
      setIsLoading(true);
      const { status, data } = await axiosInstance.get(URLS.getCompanyDropdownBooking);
      if (status === 200) {
        setCompanyMasters(createDropdownData(data, ['id', 'name']));
      }
    } catch (error: any) {
      handleCatch(error);
    } finally {
      setIsLoading(false);
    }
  }, [handleCatch]);

  const getSalutation = useCallback(async () => {
    const { data } = await axiosInstance(URLS.getSalutations);
    setSalutations(createDropdownData(data, ['id', 'name']));
  }, []);

  useEffect(() => {
    (async () => {
      console.log(pageResponse?.corporateBooking);
      if (pageResponse.corporateBooking === 'true') {
        await getMasterData();
        await getSalutation();
      }
    })();
  }, [getMasterData, getSalutation]);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      getDropdowns(),
      // getRoomsList()
    ])
      .then(() => {
        setIsLoading(false);
      })
      .catch((error: any) => handleCatch(error));
  }, [handleCatch]);

  useEffect(() => {
    if (salesManagementEnabled && id) return;
    setPageResponse((prevState: any) => ({
      ...prevState,
      corporateBooking: salesManagementEnabled ? 'true' : 'false',
    }));
  }, [salesManagementEnabled, id]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let salesParam: any;
    const startDateParam = params.get('startDate');
    const endDateParam = params.get('endDate');
    const datePrefill =
      startDateParam && dayjs(startDateParam, 'YYYY-MM-DD', true).isValid()
        ? {
            startDate: startDateParam,
            endDate: endDateParam && dayjs(endDateParam, 'YYYY-MM-DD', true).isValid() ? endDateParam : startDateParam,
          }
        : null;

    if (params.get('companyBranch')) {
      const companyBranch = params.get('companyBranch');
      const companyMaster = params.get('companyMaster');
      const contactedWith = params.get('contactedWith');
      salesParam = {
        companyBranch,
        companyMaster,
        contactedWith,
        corporateBooking: 'true',
      };
      if (branches?.length === 0) {
        getDefaultBranches(Number(companyMaster), Number(companyBranch));
      }

      if (contacts?.length === 0) {
        getDefaultContacts(Number(companyMaster), Number(companyBranch));
      }
    }
    if (location.pathname === routes.addBooking && org?.organizations?.length > 1 && !directBooking) {
      setPageResponse((prevState: any) => ({
        ...prevState,
        eventType: selectedVenues?.[0]?.eventType,
        startDate: selectedVenues?.[0]?.bookingStartDate,
        endDate: selectedVenues?.[0]?.bookingEndDate,
        minConfirmPaymentPercentage: paymentDetails.minConfirmPaymentPercentage,
        paymentSlotOnePercentage: paymentDetails.paymentSlotOnePercentage,
        paymentSlotTwoPercentage: paymentDetails.paymentSlotTwoPercentage,
        paymentSlotThreePercentage: paymentDetails.paymentSlotThreePercentage,
        paymentSlotOneBeforeDays: paymentDetails.paymentSlotOneBeforeDays,
        paymentSlotTwoBeforeDays: paymentDetails.paymentSlotTwoBeforeDays,
        fullPaymentBeforeDays: paymentDetails.fullPaymentBeforeDays,
        holdDays: paymentDetails.holdDays,
        bookingConfirmationBy: paymentDetails.bookingConfirmationBy,
        ...salesParam,
        ...(datePrefill || {}),
      }));
      setSelectedStartDate(datePrefill?.startDate || selectedVenues?.[0]?.bookingStartDate || null);
      setSelectedEndDate(datePrefill?.endDate || selectedVenues?.[0]?.bookingEndDate || null);
      setSelectedEventType(selectedVenues?.[0]?.eventType);
      setLineItems(selectedVenues);
    } else {
      //new booking from single organizations or clone booking
      setPageResponse((prevState: any) => ({
        ...prevState,
        minConfirmPaymentPercentage: paymentDetails.minConfirmPaymentPercentage,
        paymentSlotOnePercentage: paymentDetails.paymentSlotOnePercentage,
        paymentSlotTwoPercentage: paymentDetails.paymentSlotTwoPercentage,
        paymentSlotThreePercentage: paymentDetails.paymentSlotThreePercentage,
        paymentSlotOneBeforeDays: paymentDetails.paymentSlotOneBeforeDays,
        paymentSlotTwoBeforeDays: paymentDetails.paymentSlotTwoBeforeDays,
        fullPaymentBeforeDays: paymentDetails.fullPaymentBeforeDays,
        holdDays: paymentDetails.holdDays,
        bookingConfirmationBy: paymentDetails.bookingConfirmationBy,
        ...salesParam,
        ...(datePrefill || {}),
      }));
      if (datePrefill) {
        setSelectedStartDate(datePrefill.startDate);
        setSelectedEndDate(datePrefill.endDate);
      }
    }
  }, [directBooking, location, org, paymentDetails, selectedVenues]);

  useEffect(() => {
    if (!baseVenueList.length) return;
    setVenueList(buildVenuesForEventType(baseVenueList, venueEventCapacities, selectedEventType));
  }, [selectedEventType, baseVenueList, venueEventCapacities]);

  useEffect(() => {
    (async () => {
      try {
        if (selectedEventType !== '' && selectedVenue !== '') {
          closeNotification(false);
          setIsLoading(true);

          const { status, data } = await axiosInstance.get(
            URLS.getDropdownsForVenueConfig(selectedEventType, selectedVenue, pageResponse.corporateBooking),
          );
          if (status === 200) {
            setVenueMaxCapacity(data?.maximumBookCapacity ?? null);
            setAddonsList(data?.addOns);
            setHourlyPricing(data?.hourlyPricing);
            setPricePackageList(
              data?.pricePackages?.map((p: any) => ({
                label: p.name,
                value: p.id,
                pricePerPerson: p.pricePerPerson,
              })),
            );
            setLayoutList(createLayoutDropdownData(data?.layouts));
            setTaxGroupList(createDropdownData(data?.taxAndScDetails?.taxGroups, ['id', 'name']));
            setDefaultMinimumRevenue(data?.minimumRevenue);
            setDefaultPricePerHour(data?.pricePerHour);
            setFixedHallRental(data?.fixedHallRental);
            setIsOdc(data?.isOdc);
            setDefaultPricePerPerson(
              data?.pricePackages?.find((p: any) => p.id === lineItemsPageResponse.pricePackage)?.pricePerPerson,
            );

            setLineItemsPageResponse((prevState: any) => {
              const start = parseTimeValue(prevState.startTime as string);
              const end = parseTimeValue(prevState.endTime as string);
              const diff = start && end ? end.diff(start, 'hours', true).toFixed(1) : '0';
              return {
                ...prevState,
                pricePackage: !!prevState.pricePackage
                  ? prevState.pricePackage
                  : !!data.pricePackages
                  ? data.pricePackages.length > 1
                    ? ''
                    : data.pricePackages[0]?.id
                  : '',
                postLeadTime: prevState.postLeadTime ? prevState.postLeadTime : data?.postLeadTime,
                preLeadTime: prevState.preLeadTime ? prevState.preLeadTime : data?.preLeadTime,
                pricePerHour: prevState.pricePerHour ? prevState.pricePerHour : data?.pricePerHour,
                totalRental: (diff as any) * (prevState.pricePerHour ? prevState.pricePerHour : data?.pricePerHour),

                taxGroupOnGuestCharge:
                  prevState.taxGroupOnGuestCharge || data?.taxAndScDetails?.selectedTaxGroupOnGuestCharge?.value || '',

                taxGroupOnHallRental:
                  prevState.taxGroupOnHallRental || data?.taxAndScDetails?.selectedTaxGroupOnHallRental?.value || '',

                serviceChargePercentage: prevState.serviceChargePercentage
                  ? prevState.serviceChargePercentage
                  : data?.taxAndScDetails.serviceChargePercentage,
                excessGuestsPercentage: Number(data?.excessGuestsPercentage) || 0,
              };
            });
          }
        } else {
          setVenueMaxCapacity(null);
        }
      } catch (error: any) {
        handleCatch(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [
    closeNotification,
    handleCatch,
    lineItemsPageResponse.pricePackage,
    selectedEventType,
    selectedVenue,
    pageResponse.corporateBooking,
  ]);

  const getInitialResponse = useCallback(async () => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.get(cloneFromRFQ ? URLS.cloneBookingFromRfq(id) : URLS.cloneBooking(id));
      let startDate = data.startDate;
      let endDate = data.endDate;
      setPageResponse((prevState: any) => {
        if (!!prevState.startDate) {
          startDate = prevState.startDate;
        }
        if (!!prevState.endDate) {
          endDate = prevState.endDate;
        }
        return {
          ...prevState,
          ...data,
          corporateBooking: salesManagementEnabled ? resolveClonedCorporateBooking(data) : 'false',
          firstName: data.customerFirstName,
          lastName: data.customerLastName,
          phone: data.phoneNumber,
          companyName: data.companyName,
          companyMaster: data.companyMaster ?? '',
          companyBranch: data.companyBranch ?? '',
          contactedWith: data.contactedWith ?? '',
          agentId: data.agent?.value,
          revenueOwner: data.revenueOwner?.value || null,
          eventType: data.eventType?.value,
          startDate,
          endDate,
          loyaltyReferenceNo: data.loyaltyProgram?.referenceNo,
          loyaltyName: data.loyaltyProgram?.name,
          loyaltyRemark: data.loyaltyProgram?.remark,
        };
      });
      if (data.companyMaster && data.companyBranch) {
        await getDefaultBranches(Number(data.companyMaster), Number(data.companyBranch));
        await getDefaultContacts(Number(data.companyMaster), Number(data.companyBranch));
        await getRevenueOwners(Number(data.companyBranch));
      }
      setRooms(
        data.rooms.map((item: any) => ({
          ...item,
          from: null,
          to: null,
          taxGroup: item.taxGroup?.value ?? item.taxGroup ?? '',
          taxGroupName: item.taxGroup?.label ?? item.taxGroupName ?? '',
        })),
      );
      setLineItems(
        data.lineItems.map((item: any) => ({
          ...item,
          venue: item.venue?.value,
          startTime: item.startTime,
          endTime: item.endTime,

          pricePackage: item?.pricePackage?.value,
          pricePackageObj: item?.pricePackage,

          taxCode: item.taxCode?.value,
          taxCodeObj: item.taxCode,

          layout: item.layout?.value,
          layoutObj: item.layout,

          serviceCharge: item.serviceCharge?.value,
          status: item.status?.value,
          partOfDay: item.partOfDay,
          guests: item.expectedGuests,
          excessGuestsPercentage: item.excessGuestsPercentage ?? 0,
          startDate,
          endDate,
          addOns: item.addOns
            .filter((ele: any) => ele.selected === true)
            .map((ele: any) => ({
              addOnId: ele.id,
              name: ele.name,
              id: ele.bookedAddOnId,
              quantity: ele.quantity,
              type: ele.addOnType,
              price: ele.price,
            })),
        })),
      );
      setSelectedEventType(data.eventType?.value);
      if (data.additionalComments) {
        setAdditionalComments(data.additionalComments);
      }
    } catch (error: any) {
      handleCatch(error);
    } finally {
      setIsLoading(false);
    }
  }, [cloneFromRFQ, handleCatch, id, salesManagementEnabled]);

  useEffect(() => {
    (async () => {
      if (id) {
        await getInitialResponse();
      }
    })();
  }, [getInitialResponse, id]);

  const getBranches = async (companyMasterId: number) => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance(URLS.getCompanyBranchesDropdown(companyMasterId));

      if (data.length === 0) {
        setMessage({
          display: true,
          severity: 'error',
          message: 'please add branch first',
        });
      }
      formRef1.current?.handleChange('', 'branch', { error: false, message: '' });

      setBranches(createDropdownData(data, ['id', 'name']));
      setPageResponse((prevState: any) => ({
        ...prevState,
        companyMaster: companyMasterId,
        companyBranch: '',
      }));
    } catch (error: any) {
      setBranches([]);
      handleCatch(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getDefaultBranches = async (companyMasterId: number, companyBranch: number) => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance(URLS.getCompanyBranchesDropdown(companyMasterId));
      setBranches(createDropdownData(data, ['id', 'name']));
    } catch (error: any) {
      setBranches([]);
      handleCatch(error);
    }
  };
  const getDefaultContacts = async (companyMasterId: number, branchId: number) => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance(URLS.getOrAddBranchContact(companyMasterId, branchId));
      setContacts(createDropdownData(data, ['id', 'name']));
      setContactsFullData(data || []);
    } catch (error: any) {
      setContacts([]);
      setContactsFullData([]);
      handleCatch(error);
    }
  };

  const getContactsList = useCallback(
    async (branchId: any) => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance(URLS.getOrAddBranchContact(pageResponse.companyMaster, branchId));
        formRef1.current?.handleChange('', 'contactedWith', { error: false, message: '' });
        const currentSelectedContacts = pageResponse.contactedWith ?? [];

        const contactsWithAddNew = createDropdownData(data, ['id', 'name']);

        setContacts(contactsWithAddNew);
        // Store full contact data to access GSTIN
        setContactsFullData(data || []);
        setPageResponse((prevState: any) => ({
          ...prevState,
          companyBranch: branchId,
          // Preserve existing selections when refreshing
          contactedWith: branchId !== prevState.companyBranch ? [] : currentSelectedContacts,
        }));
      } catch (error: any) {
        handleCatch(error);
      } finally {
        setIsLoading(false);
      }
    },
    [handleCatch, pageResponse.companyMaster, pageResponse.contactedWith],
  );

  const handlePaymentScheduleChange = useCallback((field: string, value: unknown) => {
    setPageResponse((prevState: any) => ({ ...prevState, [field]: value }));
    setPaymentScheduleErrors(prev => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });
  }, []);

  const handleCustomResponseHelper = (custom: any, isPreview: boolean = false) => {
    const dates = lineItems?.filter((item: any) => item.startDate === undefined);
    const roomDatesFrom = rooms?.filter((item: any) => item.from === undefined || item.from === null);
    const roomDatesTo = rooms?.filter((item: any) => item.to === undefined || item.to === null);
    const statusList = lineItems?.filter((item: any) => item.status === '' || item.status === undefined);
    const missingPricePackageLineItems = lineItems?.filter((item: any) => item.pricePackage === '');

    // Check for mixed status validation (only for non-preview operations)
    const hasEnquiryItems = lineItems?.some((item: any) => item.status === 'ENQUIRY');
    const hasOtherItems = lineItems?.some(
      (item: any) => item.status !== 'ENQUIRY' && item.status !== '' && item.status !== undefined,
    );

    if (!dayjs(custom.endDate).isSameOrAfter(dayjs(custom.startDate))) {
      setGridError(true);
      throw new Error(strings.common_endDate_error_message);
    } else if (!lineItems || lineItems.length === 0) {
      setGridError(true);
      throw new Error(strings.lineItemError);
    } else if (dates?.length > 0) {
      setGridError(true);
      throw new Error(strings.newBookingStartDateError);
    } else if (statusList?.length > 0) {
      setGridError(true);
      throw new Error(strings.lineItemStatusRequiredText);
    } else if (missingPricePackageLineItems?.length > 0) {
      setGridError(true);
      throw new Error(strings.lineItemPricePackageRequiredText);
    } else if (roomDatesFrom?.length > 0 || roomDatesTo?.length > 0) {
      setRoomGridError(true);
      throw new Error(strings.roomsDateRequiredText);
    } else if (!isPreview && hasEnquiryItems && hasOtherItems) {
      setGridError(true);
      throw new Error(
        'Cannot mix ENQUIRY status with other statuses. Please use either all ENQUIRY items or all other status items.',
      );
    }
  };

  const createCustomResponse = (custom: any, venuesOverride?: any[]) => {
    const venuesSource = venuesOverride ?? lineItems;
    const body = {
      ...custom,
      firstName: custom.firstName?.hasOwnProperty('firstName') ? custom.firstName.firstName : custom.firstName,
      phone: custom.phone === '' || custom.phone?.value === '' ? null : custom.phone,
      agentId: custom.agentId || '',
      revenueOwners: fetchIdsFromSelectedDropdownValues(custom.revenueOwners),
      startDate: dayjs(custom.startDate).format('DD-MM-YYYY'),
      endDate: dayjs(custom.endDate).format('DD-MM-YYYY'),
      holdDays: Number(custom.holdDays),
      bookedRooms:
        includeRoomsTab && !useYcsRooms
          ? rooms.map((data: any) => {
              const { taxCodes: _legacyTaxCodes, ...room } = data;
              return {
                ...room,
                price: data.pricePerDay,
                taxGroupId: data.taxGroup?.value ?? data.taxGroup ?? null,
              };
            })
          : [],
      externalBookedRooms: includeRoomsTab && useYcsRooms ? externalBookedRooms : [],
      additionalComments: additionalComments,
      rfqId: cloneFromRFQ ? id : null,
      loyaltyProgram:
        (custom.loyaltyReferenceNo === undefined &&
          custom.loyaltyName === undefined &&
          custom.loyaltyRemark === undefined) ||
        (custom.loyaltyReferenceNo === '' && custom.loyaltyName === '' && custom.loyaltyRemark === '')
          ? null
          : {
              referenceNo: custom.loyaltyReferenceNo === '' ? null : custom.loyaltyReferenceNo,
              name: custom.loyaltyName === '' ? null : custom.loyaltyName,
              remark: custom.loyaltyRemark === '' ? null : custom.loyaltyRemark,
            },
      venues: venuesSource.map((item: any) => ({
        ...item,
        layout: item.layout || '',
        pricePackageId: item.pricePackage,
        customPricePackageName: isCustomizePackage(item.pricePackage, pricePackageList)
          ? normalizeCustomPricePackageName(item.customPricePackageName)
          : null,
        startDate: item.startDate && dayjs(item.startDate as string).format('DD-MM-YYYY'),
        endDate: item.endDate && dayjs(item.endDate as string).format('DD-MM-YYYY'),
        taxGroupOnGuestChargeId: (item.taxGroupOnGuestCharge as any)?.value ?? item.taxGroupOnGuestCharge ?? null,
        taxGroupOnHallRentalId: (item.taxGroupOnHallRental as any)?.value ?? item.taxGroupOnHallRental ?? null,
        serviceChargePercentage: item.serviceCharge?.hasOwnProperty('value')
          ? item.serviceCharge.value
          : item.serviceChargePercentage,
      })),
      attachContract: (document.getElementById('attachContract') as any)?.checked,
      attachPI: (document.getElementById('attachPI') as any)?.checked,
      attachProposal: (document.getElementById('attachProposal') as any)?.checked,
      complementary: isComplementary,
    };
    const { loyaltyReferenceNo, loyaltyName, loyaltyRemark, ...rest } = body;
    return rest;
  };

  const handleCustomResponse = (pageData: any, isPreview: boolean = false) => {
    handleCustomResponseHelper(pageData, isPreview);
    return createCustomResponse(pageData);
  };

  const handleLineItemFormChange = (field: string) => {
    if (field === 'timeSlot' || field === 'pricePackage') {
      if (selectedVenue === '') {
        setMessage({
          display: true,
          severity: 'error',
          message: strings.new_booking_venue_error,
        });
      } else if (selectedEventType === '') {
        setMessage({
          display: true,
          severity: 'error',
          message: strings.new_booking_segment_error,
        });
      }
    }
  };

  const handleChange = async (field: string, value: any) => {
    if (field === 'companyMaster') {
      await getBranches(value);
      setPageResponse((prevState: any) => ({ ...prevState, [field]: value, companyBranch: '', contactedWith: '' }));
    } else if (field === 'companyBranch') {
      await getContactsList(value);
      setPageResponse((prevState: any) => ({
        ...prevState,
        [field]: value,
        contactedWith: '',
        revenueOwners: [],
        gst: '',
      }));
      if (formRef1.current) {
        formRef1.current.handleChange('', 'gst', { error: false, message: '' });
        formRef1.current?.handleChange([] as any, 'revenueOwners', { error: false, message: '' });
      }

      await getRevenueOwners(value);
    } else if (field === 'corporateBooking') {
      setPageResponse((prevState: any) => ({
        ...prevState,
        [field]: value,
        revenueOwners: [],
      }));
      formRef1.current?.handleChange([] as any, 'revenueOwners', { error: false, message: '' });
      if (value === 'false') {
        await getRevenueOwners(null);
      } else if (value === 'true') {
        const branchId = pageResponse.companyBranch || null;
        await getRevenueOwners(branchId);
      }
    } else if (field === 'contactedWith') {
      if (value === 'add_new') {
        setShowContactModal(true);
        setPageResponse((prevState: any) => ({
          ...prevState,
          contactedWith: '',
        }));
      } else {
        const contactId = typeof value === 'object' ? value.value : value;
        const selectedContact = contactsFullData.find((contact: any) => contact.id === contactId);
        const gstin = selectedContact?.gstNo || '';
        setPageResponse((prevState: any) => ({
          ...prevState,
          [field]: value,
          gst: gstin,
        }));

        if (formRef1.current && gstin) {
          formRef1.current.handleChange(gstin, 'gst', { error: false, message: '' });
        } else if (formRef1.current && !gstin) {
          formRef1.current.handleChange('', 'gst', { error: false, message: '' });
        }
      }
    } else if (field === 'eventType') {
      lineItemsPageResponse.pricePackage = '';
      lineItemsPageResponse.customPricePackageName = '';
      lineItemsPageResponse.layout = '';
      lineItemsPageResponse.layoutObj = '';
      lineItemsPageResponse.serviceCharge = '';
      setLayoutList([]);
      setPricePackageList([]);
      setAddonsList([]);
      setBookedAddOns([]);
      setServiceChargeList([]);
      let obj = lineItems?.map((item: any) => ({
        ...item,
        layout: '',
        layoutObj: { label: '', value: '' },
        pricePackage: '',
        customPricePackageName: '',
        pricePackageObj: { label: '', value: '' },
        taxCode: '',
        taxCodeObj: { label: '', value: '' },
      }));
      setLineItems(obj);
      setSelectedEventType(value as string);
      setVenueMaxCapacity(null);
      setPageResponse((prevState: any) => ({
        ...prevState,
        [field]: value,
      }));
    } else if (field === 'firstName' && typeof value === 'object' && value !== null) {
      const { firstName, id, email, phone, companyName, lastName, gst, loyaltyReference } = value;
      setPageResponse((prevState: any) => ({
        ...prevState,
        id,
        firstName,
        email,
        lastName,
        phone,
        companyName,
        gst,
        loyaltyReferenceNo: loyaltyReference,
        loyaltyName: loyaltyReference ? (firstName || '') + ' ' + (lastName || '') : '',
        loyaltyRemark: '',
      }));
    } else if (field === 'firstName') {
      setPageResponse((prevState: any) => {
        const hadSelectedCustomer = prevState.id != null && prevState.id !== '';
        if (!hadSelectedCustomer) {
          return { ...prevState, firstName: value };
        }
        return {
          ...prevState,
          firstName: value,
          id: '',
          email: '',
          lastName: '',
          phone: { countryCode: prevState.phone?.countryCode ?? null, value: '' },
          companyName: '',
          gst: '',
          loyaltyReferenceNo: '',
          loyaltyName: '',
          loyaltyRemark: '',
        };
      });
    } else if (field === 'startDate' || field === 'endDate') {
      let arr;
      if (field === 'startDate') {
        if (dayjs(value).isValid()) {
          flushSync(() => {
            setPageResponse((prevState: any) => ({
              ...prevState,
              startDate: value,
              endDate: value,
            }));
          });
          setSelectedStartDate(value);
          setSelectedEndDate(value);
          arr = lineItems?.map((lineItem: any) => ({ ...lineItem, endDate: value, startDate: value }));
        }
      }
      if (field === 'endDate') {
        if (dayjs(value).isValid()) {
          setSelectedEndDate(value);
          setPageResponse((prevState: any) => ({
            ...prevState,
            endDate: value,
          }));
          arr = lineItems?.map((lineItem: any) => ({ ...lineItem, endDate: value }));
        }
      }
      if (arr) {
        setLineItems(arr);
        setMessage({
          display: lineItems && lineItems.length > 0,
          severity: 'info',
          message: strings.lineItemDateError,
        });
      }
    } else {
      setPageResponse((prevState: any) => ({
        ...prevState,
        [field]: value,
      }));
    }
  };

  const resetVenueConfigForLineItemDrawer = () => {
    setSelectedVenue('');
    setVenueMaxCapacity(null);
    setBookedAddOns([]);
    setLayoutList([]);
    setPricePackageList([]);
    setTaxGroupList([]);
    setAddonsList([]);
    setServiceChargeList([]);
    setDefaultMinimumRevenue('');
    setDefaultPricePerPerson('');
    setDefaultPricePerHour('');
    setFixedHallRental(undefined);
  };

  const handleCloneLineItem = (idx: number) => {
    const source = lineItems[idx];
    if (!source) return;
    setSelectedRowId(null);
    setIsEditDrawer(false);
    setIsCloneDrawer(true);
    resetVenueConfigForLineItemDrawer();
    setLineItemsPageResponse(buildClonedLineItemDrawerState(source));
    setOpenDrawer(true);
  };

  const getInitialState = () => {
    setPageResponse({ corporateBooking: 'false' });
    dispatch(setOpenPanelAddon(undefined));
    setOpenDrawer(false);
    setIsEditDrawer(false);
    setIsCloneDrawer(false);
    setLineItemsPageResponse({});
    setLineItems([]);
    setHasError(false);
    setSelectedRowId(null);
    setSourceList([]);
    setEventTypeList([]);
    setVenueList([]);
    setBaseVenueList([]);
    setVenueEventCapacities([]);
    setVenueMaxCapacity(null);
    setServiceChargeList([]);
    setStatusList([]);
    setLayoutList([]);
    setPricePackageList([]);
    setTaxGroupList([]);
    setServiceChargeList([]);
    setSelectedVenue('');
    setSelectedEventType('');
    setAddonsList([]);
    setMaxCount(0);
    setRooms([]);
    setIsComplementary(false);
    removeFromStorage('cloneFromRFQ', true);
  };

  const downloadContract = async (type: any, datavalue?: undefined) => {
    await downloadContractHelper(type, screenSizeDownSm ? datavalue : pageRequest);
  };

  const downloadContractHelper = async (type: any, datavalue?: undefined) => {
    setIsLoading(true);
    axios({
      url: `${Config.BaseURL + URLS.bookingPreviewTemplatePdf}?type=${type}`,
      method: 'POST',
      data: datavalue,
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    })
      .then(response => {
        setIsLoading(false);
        downloadExportFile(response, 'pdf', getFileName(type));
      })
      .catch(err => {
        if (err.response) {
          if (err?.response?.status === 403) {
            setMessage({
              display: true,
              severity: 'error',
              message: strings.forbidden,
            });
          } else {
            setMessage({
              display: true,
              severity: 'error',
              message: err.response?.data.message,
            });
          }
        } else {
          setMessage({
            display: true,
            severity: 'error',
            message: err.message,
          });
        }
        setIsLoading(false);
      });
  };

  const handleCalculateBill = async () => {
    try {
      const custom = await handleFormValidation();
      if (custom) {
        handleCustomResponseHelper(custom, false);
        const body = createCustomResponse(custom);
        setIsLoading(true);
        const { status, data } = await axiosInstance.post(URLS.calculateBill, body);
        if (status === 200 || status === 201) {
          setCostingDrawerPageResponse(data);
        }
      }
    } catch (error: any) {
      debugger;
      handleCatch(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitWithSendEmail = async (customOverride?: any, alreadyLocked = false) => {
    if (!alreadyLocked) {
      if (savingRef.current) return;
      savingRef.current = true;
    }
    let created = false;
    try {
      const effectiveCustom = customOverride ?? pageData;
      const requestBody = handleCustomResponse(effectiveCustom, false);
      const { getFormData } = sendEmailFormRef.current as {
        getFormData: () => { formData: FormDataModel; isFormValid: boolean };
      };
      const { formData, isFormValid } = getFormData();
      setSendEmailHasError(false);
      if (isFormValid) {
        const emailFormData = removeErrorFieldsFromValues(formData);
        setIsSaving(true);
        setIsLoading(true);
        const { data, status } = await axiosInstance.post(URLS.sendNewBookingData, requestBody, {
          headers: { 'X-Request-Id': bookingIdempotencyKeyRef.current },
        });
        if (status === 200 || status === 201) {
          created = true;
          const body = new FormData();
          attachment.forEach((file: any) => {
            body.append('files', file);
          });
          if (attachment.length === 0) {
            body.append('files', null as any);
          }

          body.append('deletedFiles', deletedImage);
          body.append('to', emailFormData.to);
          body.append('cc', emailFormData.cc);
          body.append('bcc', emailFormData.bcc);
          body.append('type', 'NEW_BOOKING');
          appendEmailAttachmentOptions(body, emailAttachmentVisibility);

          const config = {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          };

          const { status } = await axiosInstance.post(URLS.sendBookingEmailAttachment(data.id), body, config);
          if (status === 200 || status === 201) {
            setDeletedImage('');
            setMessage({
              display: true,
              severity: 'success',
              message: NotificationAction(data),
            });
            setTimeout(() => Navigate(routes.bookings), 2000);
          }
        }
      } else {
        setSendEmailHasError(true);
      }
    } catch (error: any) {
      handleCatch(error);
    } finally {
      setIsLoading(false);
      if (!created) {
        savingRef.current = false;
        setIsSaving(false);
      }
    }
  };

  const handleFormValidation = async (isPreview: boolean = false) => {
    try {
      const getFormData1 = formRef1.current as {
        getFormData: () => { formData: FormDataModel; isFormValid: boolean };
      };
      const a = getFormData1.getFormData();
      const formData1 = a.formData;
      const isFormValid1 = a.isFormValid;

      const getFormData2 = formRef2.current as {
        getFormData: () => { formData: FormDataModel; isFormValid: boolean };
      };
      const b = getFormData2.getFormData();
      const formData2 = b.formData;
      const isFormValid2 = b.isFormValid;

      const paymentValues = pickPaymentScheduleValues(pageResponse);
      const paymentValidation = validatePaymentSchedule(paymentValues);
      const formData = { ...formData1, ...formData2, ...paymentValues };
      const body = removeErrorFieldsFromValues(formData);
      setHasError(false);

      if (isFormValid1 && isFormValid2 && paymentValidation.valid) {
        setPaymentScheduleErrors({});
        return body;
      } else {
        flushSync(() => setHasError(true));
        setPaymentScheduleErrors(paymentValidation.errors);
        setTimeout(() => {
          const element = document.querySelector('.Mui-error');
          element?.scrollIntoView({ behavior: 'smooth' });
        }, 200);
        setMessage({
          display: true,
          severity: 'error',
          message: `${strings.required_error_prefix_message} ${fetchErrorFields(formData, [
            ...NewBookingForm(
              strings,
              sourceList,
              eventTypeList,
              false,
              defaultCountry,
              pageResponse.corporateBooking,
              companyMasters,
              branches,
              contacts,
              salesManagementEnabled,
              revenueOwnerList,
              pastBookingWindowDays,
            ),
            ...NewBookingForm2(strings, bookingConfirmationList, captureLoyaltyProgram, new Date()),
          ]).join(', ')}`,
        });
        return false;
      }
    } catch (error: any) {
      handleCatch(error);
    }
  };

  const handleCreateFromReview = async () => {
    if (savingRef.current || isLoading || isSaving) return;
    savingRef.current = true;
    setIsSaving(true);
    try {
      const body = await handleFormValidation();
      if (!body) {
        savingRef.current = false;
        setIsSaving(false);
        return;
      }
      handleCustomResponseHelper(body);
      setPageData(body);
      await handleSubmitWithSendEmail(body, true);
    } catch (error: any) {
      handleCatch(error);
      savingRef.current = false;
      setIsSaving(false);
    }
  };

  const getBookingFormDataForCosting = useCallback((): Record<string, any> | null => {
    const paymentValues = pickPaymentScheduleValues(pageResponse);
    const f1 = formRef1.current as any;
    const f2 = formRef2.current as any;
    if (f1?.getFormData && f2?.getFormData) {
      return removeErrorFieldsFromValues({
        ...f1.getFormData().formData,
        ...f2.getFormData().formData,
        ...paymentValues,
      });
    }
    const snapshot = pageData ?? pageResponse;
    if (!snapshot?.startDate || !snapshot?.endDate) return null;
    return removeErrorFieldsFromValues({
      ...snapshot,
      ...paymentValues,
    });
  }, [pageData, pageResponse]);

  const fetchCosting = useCallback(
    async (venuesOverride?: any[], options?: { usePageLoader?: boolean; lineItemSummaryOnly?: boolean }) => {
      const requestSeq = options?.lineItemSummaryOnly ? ++costingSummaryRequestSeqRef.current : 0;
      try {
        const body = getBookingFormDataForCosting();
        const venues = venuesOverride ?? lineItems;
        if (!body || !body.startDate || !body.endDate || !body.eventType || !venues || venues.length === 0) return;

        const readyVenues = venues.filter((item: any) =>
          isLineItemReadyForCosting(item, !!item?.hourlyPricing || hourlyPricing),
        );
        if (readyVenues.length === 0) {
          if (options?.lineItemSummaryOnly) {
            setCostingDrawerPageResponse({});
            setCostingSummaryError(null);
          }
          return;
        }

        if (options?.usePageLoader) {
          setIsLoading(true);
        } else if (options?.lineItemSummaryOnly) {
          setCostingSummaryLoading(true);
        }
        const requestBody = createCustomResponse(body, readyVenues);
        if (options?.lineItemSummaryOnly) {
          requestBody.bookedRooms = [];
          requestBody.externalBookedRooms = [];
        }
        const { status, data } = await axiosInstance.post(URLS.calculateBill, requestBody);
        if (options?.lineItemSummaryOnly && requestSeq !== costingSummaryRequestSeqRef.current) {
          return;
        }
        if (status === 200 || status === 201) {
          setCostingDrawerPageResponse(data);
          if (options?.lineItemSummaryOnly) {
            setCostingSummaryError(null);
          }
        }
      } catch (error: any) {
        if (options?.lineItemSummaryOnly && requestSeq !== costingSummaryRequestSeqRef.current) {
          return;
        }
        if (options?.lineItemSummaryOnly) {
          setCostingDrawerPageResponse({});
          setCostingSummaryError(extractCostingErrorMessage(error, strings.new_booking_event_summary_error));
        }
        setMessage({
          display: true,
          severity: 'error',
          message: extractCostingErrorMessage(error, strings.new_booking_event_summary_error),
        });
      } finally {
        if (options?.usePageLoader) {
          setIsLoading(false);
        } else if (options?.lineItemSummaryOnly) {
          if (requestSeq === costingSummaryRequestSeqRef.current) {
            setCostingSummaryLoading(false);
          }
        } else {
          setCostingSummaryLoading(false);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      lineItems,
      rooms,
      externalBookedRooms,
      additionalComments,
      useYcsRooms,
      pageResponse,
      pageData,
      getBookingFormDataForCosting,
      hourlyPricing,
    ],
  );

  const calculateChargesSilently = useCallback(async () => {
    await fetchCosting(undefined, { usePageLoader: true });
  }, [fetchCosting]);

  const calculateVenueDetailsCosting = useCallback(
    async (draftLineItem: Record<string, any> | null, draftSelectedRowId: number | null) => {
      // Incomplete draft while adding/editing — wait until mandatory fields are filled.
      if (draftLineItem === null && draftSelectedRowId === null) {
        setCostingDrawerPageResponse({});
        setCostingSummaryError(null);
        return;
      }
      if (draftLineItem != null && !isLineItemReadyForCosting(draftLineItem, hourlyPricing)) {
        setCostingDrawerPageResponse({});
        setCostingSummaryError(null);
        return;
      }

      const currentVenues = resolveCurrentLineItemForCosting(lineItems, draftLineItem, draftSelectedRowId);
      const readyVenues = currentVenues.filter((item: any) =>
        isLineItemReadyForCosting(item, !!item?.hourlyPricing || hourlyPricing),
      );
      if (readyVenues.length === 0) {
        setCostingDrawerPageResponse({});
        setCostingSummaryError(null);
        return;
      }
      await fetchCosting(readyVenues, { lineItemSummaryOnly: true });
    },
    [fetchCosting, lineItems, hourlyPricing],
  );

  const resolveLineItemTotalOnSave = useCallback(
    async (
      lineItemPayload: Record<string, any>,
      rowId: number | null,
    ): Promise<
      { ok: true; total: string; totalUnformatted: number | null } | { ok: false; message: string } | null
    > => {
      if (!isLineItemReadyForCosting(lineItemPayload, hourlyPricing)) {
        return { ok: false, message: strings.requiredText };
      }
      const currentVenues = resolveCurrentLineItemForCosting(lineItems, lineItemPayload, rowId);
      if (currentVenues.length === 0) return null;
      const body = getBookingFormDataForCosting();
      if (!body?.startDate || !body?.endDate) {
        return { ok: false, message: strings.requiredText };
      }
      try {
        const requestBody = createCustomResponse(body, currentVenues);
        requestBody.bookedRooms = [];
        requestBody.externalBookedRooms = [];
        const { status, data } = await axiosInstance.post(URLS.calculateBill, requestBody);
        if (status === 200 || status === 201) {
          return {
            ok: true,
            total: data.total ?? '',
            totalUnformatted: data.totalUnformatted ?? null,
          };
        }
        return {
          ok: false,
          message: data?.message || strings.new_booking_event_summary_error,
        };
      } catch (error: any) {
        return {
          ok: false,
          message: error?.response?.data?.message || error?.message || strings.new_booking_event_summary_error,
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lineItems, getBookingFormDataForCosting, hourlyPricing],
  );

  const handlePreviewContract = async (type: any) => {
    const custom = await handleFormValidation(true);
    if (custom) {
      const datavalue = handleCustomResponse(custom, true);
      setIsLoading(true);
      if (screenSizeDownSm) {
        await downloadContract(type, datavalue);
      } else {
        try {
          axios({
            url: `${Config.BaseURL + URLS.bookingPreviewTemplate}?type=${type}`,
            method: 'POST',
            data: datavalue,
            headers: { Authorization: `Bearer ${token}` },
          })
            .then(response => {
              setPdfUrl(response.data);
              setIsLoading(false);
              setOpenPdfDrawer(type);
              setPageRequest(datavalue);
            })
            .catch(err => {
              if (err.response) {
                setMessage({
                  display: true,
                  severity: 'error',
                  message: err.response?.data.message,
                });
              } else {
                setMessage({
                  display: true,
                  severity: 'error',
                  message: err.message,
                });
              }
            });
        } catch (err: any) {
          if (err.response) {
            setMessage({
              display: true,
              severity: 'error',
              message: err.response?.data.message,
            });
          } else {
            setMessage({
              display: true,
              severity: 'error',
              message: err.message,
            });
          }
        } finally {
          setIsLoading(false);
        }
      }
    }
  };

  const getCorporateRates = async (body: any) => {
    try {
      setIsLoading(true);
      const { data } = await axiosInstance.post(URLS.corporateRates, body);
      setLineItemsPageResponse((prevState: any) => ({ ...prevState, pricePerPerson: data.pricePerPerson }));
    } catch (err: any) {
      if (err.response) {
        setMessage({
          display: true,
          severity: 'error',
          message: err.response?.data.message,
        });
      } else {
        setMessage({
          display: true,
          severity: 'error',
          message: err.message,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowContactModal(false);
  };

  const handleAddContact = useCallback(async () => {
    try {
      setShowContactModal(false);
      await getContactsList(pageResponse.companyBranch);
    } catch (e: any) {
      handleCatch(e);
    } finally {
      setIsLoading(false);
    }
  }, [getContactsList, handleCatch, pageResponse.companyBranch]);
  const contactModal = useMemo(() => {
    return (
      <DrawerMenu
        width={'70%'}
        open={showContactModal}
        handleClose={handleModalClose}
        closeButton={true}
        title={strings.customermgmt_title_add}>
        <AddEditCustomer
          companyId={pageResponse.companyMaster}
          branchId={pageResponse.companyBranch}
          handleSave={handleAddContact}
        />
      </DrawerMenu>
    );
  }, [handleAddContact, pageResponse.companyBranch, pageResponse.companyMaster, showContactModal]);

  const roomsTabIndex = includeRoomsTab ? 1 : -1;
  const reviewTabIndex = includeRoomsTab ? 2 : 1;

  const reviewRoomCount = useMemo(() => {
    if (!includeRoomsTab) return 0;
    if (useYcsRooms) {
      return externalBookedRooms.reduce((sum, booking) => {
        const qty = booking.lineItems?.[0]?.quantity ?? 1;
        return sum + qty;
      }, 0);
    }
    return rooms.reduce((sum: number, room: any) => sum + (Number(room.numberOfRooms) || 0), 0);
  }, [includeRoomsTab, useYcsRooms, externalBookedRooms, rooms]);

  // Reusable validation function for formRef1
  const validateForm1 = useCallback(() => {
    if (formRef1.current) {
      const { getFormData } = formRef1.current as {
        getFormData: () => { formData: FormDataModel; isFormValid: boolean };
      };
      const { isFormValid } = getFormData();

      if (!isFormValid) {
        setHasError(true);
        return false;
      }
      setHasError(false);
    }
    return true;
  }, [setHasError]);

  // Validation function to check if at least one line item is added
  const validateLineItems = useCallback(() => {
    if (!lineItems || lineItems.length === 0) {
      setMessage({
        display: true,
        severity: 'error',
        message: strings.lineItemError,
      });
      return false;
    }
    return true;
  }, [lineItems?.length]);

  const prepareNewVenueDetailsForm = useCallback(() => {
    if (selectedRowId !== null) {
      setSelectedRowId(null);
    }
    setIsEditDrawer(false);
    setIsCloneDrawer(false);
    setLineItemsPageResponse({
      startDate: selectedStartDate || pageResponse.startDate,
      endDate: selectedEndDate || pageResponse.endDate,
    });
  }, [selectedRowId, selectedStartDate, selectedEndDate, pageResponse.startDate, pageResponse.endDate]);

  const openVenueDetailsDrawer = useCallback(() => {
    setOpenDrawer(true);
  }, []);

  const handleOpenVenueDetailsDrawer = useCallback(() => {
    if (!validateForm1()) return;
    prepareNewVenueDetailsForm();
    openVenueDetailsDrawer();
  }, [validateForm1, prepareNewVenueDetailsForm, openVenueDetailsDrawer]);

  const venueDetailsPageHeader = useMemo(() => {
    const formData = pageData ?? pageResponse;
    const isCorporate = pageResponse.corporateBooking === 'true';
    return {
      customerName: buildCustomerName(formData, isCorporate, companyMasters),
      eventTypeLabel: labelForId(formData.eventType, eventTypeList),
      dateRangeLabel: formatBookingDateRange(formData.startDate, formData.endDate),
    };
  }, [pageData, pageResponse, companyMasters, eventTypeList]);

  useEffect(() => {
    if (!openDrawer) return;
    calculateVenueDetailsCosting(null, selectedRowId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDrawer, lineItems?.length, selectedRowId]);

  /*
   * Whenever the user lands on the Review tab we:
   *   1) auto-compute the charges summary so the left column always reflects the latest input
   *   2) seed the inline send-email recipients (To = logged-in user + customer)
   *   3) keep `pageData` populated so the Create button can submit without re-validating
   */
  useEffect(() => {
    if (activeTab !== reviewTabIndex) return;
    const f1 = formRef1.current as any;
    const customForm = f1?.getFormData?.()?.formData ?? {};
    const customerEmail = customForm.email || '';
    const arr = customerEmail ? [loggedInUserDetails.email, customerEmail] : [loggedInUserDetails.email];
    setSendEmailPageResponse((prev: any) => ({ ...prev, to: arr.join(',') }));
    setPageData(customForm);
    calculateChargesSilently();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, reviewTabIndex]);

  return (
    <>
      {isLoading && <PageLoader />}
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
          autoHideDuration={5000}
        />
      )}
      {showContactModal && contactModal}
      <LineItemDrawerComponent
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        pageHeader={venueDetailsPageHeader}
        costingPageResponse={costingDrawerPageResponse}
        costingLoading={costingSummaryLoading}
        costingError={costingSummaryError}
        onRefreshCosting={calculateVenueDetailsCosting}
        resolveLineItemTotalOnSave={resolveLineItemTotalOnSave}
        hourlyPricing={hourlyPricing}
        isOdc={isOdc}
        isEditDrawer={isEditDrawer}
        isCloneDrawer={isCloneDrawer}
        setIsEditDrawer={setIsEditDrawer}
        setIsCloneDrawer={setIsCloneDrawer}
        lineItemFormRef={lineItemFormRef}
        lineItemsPageResponse={lineItemsPageResponse}
        setLineItemsPageResponse={setLineItemsPageResponse}
        setBookedAddOns={setBookedAddOns}
        setLayoutList={setLayoutList}
        setPricePackageList={setPricePackageList}
        setTaxGroupList={setTaxGroupList}
        setAddonsList={setAddonsList}
        setSelectedVenue={setSelectedVenue}
        setMessage={setMessage}
        setHasError={setLineItemHasError}
        bookedAddOns={bookedAddOns}
        lineItems={lineItems}
        pricePackageList={pricePackageList}
        selectedRowId={selectedRowId}
        setSelectedRowId={setSelectedRowId}
        maxCount={maxCount}
        setMaxCount={setMaxCount}
        setLineItems={setLineItems}
        hasError={lineItemHasError}
        layoutList={layoutList}
        taxGroupList={taxGroupList}
        venueList={venueList}
        statusList={statusList}
        addonsList={addonsList}
        handleLineItemFormChange={handleLineItemFormChange}
        serviceChargeList={serviceChargeList}
        setServiceChargeList={setServiceChargeList}
        selectedStartDate={selectedStartDate}
        selectedEndDate={selectedEndDate}
        defaultPricePerPerson={defaultPricePerPerson}
        setDefaultPricePerPerson={setDefaultPricePerPerson}
        defaultMinimumRevenue={defaultMinimumRevenue}
        setDefaultMinimumRevenue={setDefaultMinimumRevenue}
        defaultPricePerHour={defaultPricePerHour}
        fixedHallRental={fixedHallRental}
        setFixedHallRental={setFixedHallRental}
        corporateBooking={pageResponse.corporateBooking}
        branchId={pageResponse.companyBranch}
        getCorporateRates={getCorporateRates}
        restrictPriceOverride={restrictPriceOverride}
        partOfDays={partOfDayList}
        eventSubtypeOptions={eventSubtypeOptions}
        pastBookingWindowDays={pastBookingWindowDays}
        venueMaxCapacity={venueMaxCapacity}
      />
      <>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs>
            <Typography sx={pageTitleSx}>{strings.new_booking_title}</Typography>
          </Grid>
          {pageResponse?.corporateBooking === 'true' && (
            <Grid item>
              <PrimaryButton
                variant="outlined"
                startIcon={<AddIcon />}
                sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                fullWidth={false}
                onClick={() => Navigate(routes.addCompanyMasters)}>
                {strings.createNewCompany}
              </PrimaryButton>
            </Grid>
          )}
          {org !== '*' && (
            <Grid item>
              <Navigation url={routes.bookings} />
            </Grid>
          )}
        </Grid>

        <Divider sx={{ mt: 0.75, mb: 1 }} />

        <Box sx={{ mb: 0.5 }}>
          <Tabs
            value={activeTab}
            onChange={(_, v) => {
              // Validate form before changing tabs
              if (v === 1 && includeRoomsTab) {
                // Navigating to Rooms tab - validate formRef1
                if (!validateForm1()) return;
              } else if (v === reviewTabIndex) {
                // Navigating to Review tab - validate formRef1 and line items
                if (!validateForm1()) return;
                if (!validateLineItems()) return;
              }

              setActiveTab(v);
            }}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              borderBottom: `1px solid ${theme.palette.divider}`,
              '& .MuiTabs-indicator': {
                height: 3,
                borderRadius: 3,
                backgroundColor: 'primary.main',
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.95rem',
                minHeight: 40,
                py: 0.75,
                px: 2,
                color: 'text.secondary',
                '&:hover': {
                  backgroundColor:
                    theme.palette.mode === 'light' ? 'rgba(25, 118, 210, 0.04)' : 'rgba(144, 202, 249, 0.08)',
                },
                '&.Mui-selected': {
                  color: 'primary.main',
                },
              },
            }}>
            <Tab label="Event Details" />
            {includeRoomsTab && <Tab label="Rooms" />}
            <Tab label="Review" />
          </Tabs>
        </Box>

        {/*
          Event Details / Review tabs stay mounted so their inner refs (formRef1, formRef2)
          remain valid even when another tab is active. Without this, navigating to Review
          and clicking "Create" would unmount Event Details and crash with
          "Cannot read properties of null (reading 'getFormData')".
        */}
        <Box sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
          <>
            <Grid container spacing={2} sx={{ my: 2 }} alignItems="flex-start">
              <Form
                onFocus={handleLineItemFormChange}
                onChange={handleChange}
                hasError={hasError}
                ref={formRef1 as RefObject<Form>}
                model={NewBookingForm(
                  strings,
                  sourceList,
                  eventTypeList,
                  false,
                  defaultCountry,
                  pageResponse.corporateBooking,
                  companyMasters,
                  branches,
                  contacts,
                  salesManagementEnabled,
                  revenueOwnerList,
                  pastBookingWindowDays,
                )}
                values={pageResponse}
              />
            </Grid>

            <Box mt={2} />
            <Section label={strings.bookingLineItems} field={''} />

            <Grid container gap={1} mt={0.5} mb={0.5}>
              <Button variant="text" sx={{ width: 'max-content' }} onClick={handleOpenVenueDetailsDrawer}>
                <span style={{ marginRight: '10px' }}>{strings.new_booking_add_venue_details}</span>
                <AddCircleOutlineIcon />
              </Button>
            </Grid>

            {!lineItems || lineItems.length === 0 ? (
              <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
                <Box
                  sx={{
                    py: 2,
                    px: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}>
                  <EventNoteOutlinedIcon sx={{ fontSize: 22, color: 'text.secondary', mb: 1 }} />
                  <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.3 }}>
                    {strings.new_booking_venue_details_empty_title}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ lineHeight: 1.35, maxWidth: 420, mt: 0.35 }}>
                    {strings.new_booking_venue_details_empty_description}
                  </Typography>
                </Box>
              </Card>
            ) : (
              <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
                <div id="lineItemsTableComponent">
                  <LineItemsTableComponent
                    lineItems={lineItems}
                    setLineItems={setLineItems}
                    gridError={gridError}
                    venueList={venueList}
                    statusList={statusList}
                    partOfDayList={partOfDayList}
                    setSelectedRowId={setSelectedRowId}
                    setSelectedVenue={setSelectedVenue}
                    setLineItemsPageResponse={setLineItemsPageResponse}
                    setBookedAddOns={setBookedAddOns}
                    setIsEditDrawer={setIsEditDrawer}
                    setIsCloneDrawer={setIsCloneDrawer}
                    setOpenDrawer={setOpenDrawer}
                    onCloneRow={handleCloneLineItem}
                    selectedEventType={selectedEventType}
                  />
                </div>
              </Card>
            )}

            {/*
             * Payment details + loyalty program are part of the event-detail capture now,
             * so we render `NewBookingForm2` here. The ref stays mounted across tabs which
             * keeps `formRef2.current.getFormData()` valid when the user clicks Create on
             * the Review tab.
             */}
            <Box mt={2} />
            <PaymentScheduleSection
              values={pageResponse}
              onChange={handlePaymentScheduleChange}
              hasError={hasError}
              errors={paymentScheduleErrors}
            />
            <Grid container spacing={2} alignItems="flex-start">
              <Form
                hasError={hasError}
                ref={formRef2 as RefObject<Form>}
                model={NewBookingForm2(strings, bookingConfirmationList, captureLoyaltyProgram, new Date())}
                values={pageResponse}
              />
            </Grid>

            <Box mt={3} />
            <Section label={strings.bookingDetails_text_booking_creation_comment} field={''} />
            <CKEditor5
              label={''}
              textChange={(value: any) => setAdditionalComments(value)}
              value={additionalComments}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, mt: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                <FormControlLabel
                  sx={{ mr: 0 }}
                  control={
                    <Checkbox
                      id="complementary"
                      size="small"
                      checked={isComplementary}
                      onChange={e => setIsComplementary(e.target.checked)}
                    />
                  }
                  label={strings.markComplementary}
                />
                <Tooltip title={strings.new_booking_complementary_info} arrow placement="top">
                  <IconButton aria-label={strings.new_booking_complementary_info} size="small" sx={{ p: 0.25 }}>
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                <FormControlLabel
                  sx={{ mr: 0 }}
                  control={
                    <Checkbox
                      size="small"
                      checked={includeRoomsTab}
                      onChange={e => {
                        const checked = e.target.checked;
                        if (!checked && includeRoomsTab) {
                          setActiveTab(prev => (prev >= 1 ? 1 : prev));
                        }
                        setIncludeRoomsTab(checked);
                      }}
                    />
                  }
                  label={strings.new_booking_proceed_room_booking}
                />
                <Tooltip title={strings.new_booking_proceed_room_booking_info} arrow placement="top">
                  <IconButton aria-label={strings.new_booking_proceed_room_booking_info} size="small" sx={{ p: 0.25 }}>
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Grid container sx={{ mt: 2 }} justifyContent="flex-end">
              <Grid item xs={screenSizeDownSm && 12}>
                <PrimaryButton
                  fullWidth={!!screenSizeDownSm}
                  variant="contained"
                  onClick={() => {
                    // Validate form before navigating to rooms tab
                    if (!validateForm1()) return;

                    setActiveTab(includeRoomsTab ? 1 : reviewTabIndex);
                  }}>
                  Next
                </PrimaryButton>
              </Grid>
            </Grid>
          </>
        </Box>

        {openPdfDrawer === CONTRACT && (
          <PreviewContract
            headerText={strings.bookings_button_preview_contract}
            downloadButtonText={strings.bookings_button_download_contract}
            downloadContract={downloadContract as any}
            pdfUrl={pdfUrl}
            handleClose={() => setOpenPdfDrawer(false)}
            openPdfDrawer={openPdfDrawer}
            loading={isLoading}
          />
        )}
        {openPdfDrawer === PROPOSAL && (
          <PreviewContract
            headerText={strings.bookings_button_preview_proposal}
            downloadButtonText={strings.bookings_button_download_proposal}
            downloadContract={downloadContract as any}
            pdfUrl={pdfUrl}
            handleClose={() => setOpenPdfDrawer(false)}
            openPdfDrawer={openPdfDrawer}
            loading={isLoading}
          />
        )}
        {openPdfDrawer === ENQUIRY && (
          <PreviewContract
            headerText={strings.bookings_button_preview_enquiry}
            downloadButtonText={strings.bookings_button_download_enquiry}
            downloadContract={downloadContract as any}
            pdfUrl={pdfUrl}
            handleClose={() => setOpenPdfDrawer(false)}
            openPdfDrawer={openPdfDrawer}
            loading={isLoading}
          />
        )}
        {openPdfDrawer === PI && (
          <PreviewContract
            headerText={strings.bookings_button_preview_pi}
            downloadButtonText={strings.bookings_button_download_pi}
            downloadContract={downloadContract as any}
            pdfUrl={pdfUrl}
            handleClose={() => setOpenPdfDrawer(false)}
            openPdfDrawer={openPdfDrawer}
            loading={isLoading}
          />
        )}
        <Box mt={3}></Box>

        {includeRoomsTab && roomAvailable && (
          <Box sx={{ display: activeTab === roomsTabIndex ? 'block' : 'none' }}>
            <div id="roomstable">
              <Section label={strings.bookingDetails_booking_rooms} field={''} />
              {useYcsRooms ? (
                <YcsRoomBooking
                  eventStartDate={pageResponse.startDate}
                  eventEndDate={pageResponse.endDate}
                  onPayloadChange={setExternalBookedRooms}
                />
              ) : (
                <AddEditBookingRooms
                  isCompany={pageResponse?.corporateBooking === 'true'}
                  branchId={pageResponse.companyBranch}
                  rooms={rooms}
                  setRooms={setRooms}
                  roomGridError={roomGridError}
                  pastBookingWindowDays={pastBookingWindowDays}
                  taxGroups={taxGroupList}
                />
              )}
            </div>

            <Grid container sx={{ mt: 2 }} gap={1} justifyContent="space-between">
              <Grid item xs={screenSizeDownSm && 12}>
                <PrimaryButton fullWidth={!!screenSizeDownSm} variant="outlined" onClick={() => setActiveTab(0)}>
                  Back
                </PrimaryButton>
              </Grid>
              <Grid item xs={screenSizeDownSm && 12}>
                <PrimaryButton
                  fullWidth={!!screenSizeDownSm}
                  variant="contained"
                  onClick={() => {
                    // Validate form before navigating to review tab
                    if (!validateForm1()) return;
                    if (!validateLineItems()) return;

                    setActiveTab(reviewTabIndex);
                  }}>
                  Next
                </PrimaryButton>
              </Grid>
            </Grid>
          </Box>
        )}

        {/*
         * Review tab now renders the charges summary (left) alongside the booking
         * confirmation panel (right). Both panels stay mounted so refs remain valid
         * and the costing data persists if the user toggles tabs.
         */}
        <Box sx={{ display: activeTab === reviewTabIndex ? 'block' : 'none' }}>
          <Grid container spacing={2} sx={{ my: 2 }}>
            {/* Left: booking summary + charges, computed when entering this tab. */}
            <Grid item xs={12} md={6}>
              <ReviewTabSummary
                formData={pageData ?? pageResponse}
                eventTypeList={eventTypeList}
                companyMasters={companyMasters}
                isCorporate={pageResponse.corporateBooking === 'true'}
                isComplementary={isComplementary}
                eventCount={lineItems?.length || 0}
                roomCount={reviewRoomCount}
              />
              {Object.keys(costingDrawerPageResponse).length > 0 ? (
                <CostingComponent pageResponse={costingDrawerPageResponse} reviewLayout showStatusChip />
              ) : (
                <Card sx={{ width: '100%', my: 2 }}>
                  <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1, color: 'text.primary' }}>
                      Booking Cost Breakdown
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {strings.bookings_button_calcuate_bill
                        ? `Charges will appear once event details and line items are filled in.`
                        : ''}
                    </Typography>
                    <Box mt={1.5}>
                      <PrimaryButton variant="outlined" onClick={handleCalculateBill}>
                        {strings.bookings_button_calcuate_bill}
                      </PrimaryButton>
                    </Box>
                  </Box>
                </Card>
              )}
            </Grid>

            {/* Right: confirm/send-email panel (the contents that used to live in the drawer). */}
            <Grid item xs={12} md={6}>
              <Section label="Confirm & Notify Guest" field={''} />
              <Card sx={{ width: '100%', my: 2 }}>
                <Box sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    <Form
                      hasError={sendEmailHasError}
                      ref={sendEmailFormRef as RefObject<Form>}
                      model={NewBookingSendEmailFormComponent(strings)}
                      values={sendEmailPageResponse}
                    />
                  </Grid>
                  <EmailAttachmentCheckboxes {...emailAttachmentVisibility} sx={{ mt: 1 }} />
                  <EmailFileAttachments
                    files={Array.isArray(attachment) ? attachment : []}
                    onFilesChange={setAttachment}
                    disabled={isLoading || isSaving}
                  />

                  <Grid container spacing={1} sx={{ mt: 2 }}>
                    <Grid item xs={12} sm={6}>
                      <PrimaryButton
                        fullWidth
                        variant="contained"
                        disabled={isLoading || isSaving}
                        onClick={() => handleCreateFromReview()}>
                        {strings.common_button_create}
                      </PrimaryButton>
                    </Grid>
                    {(isContractTemplatePresent ||
                      isProposalTemplatePresent ||
                      isPiTemplatePresent ||
                      (isEnquiryTemplatePresent && lineItems?.some((item: any) => item.status === 'ENQUIRY'))) && (
                      <Grid item xs={12} sm={6}>
                        <PreviewPopover
                          isContractTemplatePresent={isContractTemplatePresent}
                          isProposalTemplatePresent={isProposalTemplatePresent}
                          isPiTemplatePresent={isPiTemplatePresent}
                          isEnquiryTemplatePresent={
                            isEnquiryTemplatePresent && lineItems?.some((item: any) => item.status === 'ENQUIRY')
                          }
                          downloadContract={downloadContract}
                          handlePreviewContract={handlePreviewContract}
                          disabled={lineItems?.length === 0}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Card>
            </Grid>
          </Grid>

          <Grid container sx={{ mt: 2 }} gap={1}>
            <Grid item xs={screenSizeDownSm && 12}>
              <PrimaryButton
                fullWidth
                variant="outlined"
                onClick={() => setActiveTab(includeRoomsTab ? roomsTabIndex : 0)}>
                Back
              </PrimaryButton>
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export default NewBooking;
